module.exports = __webpack_public_path__ + "media/images/flags/1x1/bol-3752d800292fe7ed0538485aa6ff2276.svg";